import { createSyncStore } from '../factory';

export type TitleBarGlobalSearchState = {
  visible: boolean;
  isOpen: boolean;
};

export type TitleBarGlobalSearchActions = {
  setVisible: (visible: boolean) => void;
  setOpen: (isOpen: boolean) => void;
  toggleOpen: () => void;
};

export const createTitleBarGlobalSearchStore = (origin?: string) =>
  createSyncStore<TitleBarGlobalSearchState, TitleBarGlobalSearchActions>({
    channel: 'title-bar-global-search',
    syncKeys: ['visible', 'isOpen'],
    throttleMs: 50,
    state: {
      visible: false,
      isOpen: false,
    },
    actions: (set, get) => ({
      setVisible: (visible) => set({ visible }),
      setOpen: (isOpen) => set({ isOpen }),
      toggleOpen: () => set({ isOpen: !get().isOpen }),
    }),
    syncOptions: { broadcastInitialState: false, ...(origin ? { origin } : {}) },
  });
